import {
  CourseOrderTypesApiModel,
  CourseOrderTypesModel,
} from './courseOrderTypes.model';

export const courseOrderTypesAdapter = ({
  data,
}: CourseOrderTypesApiModel): CourseOrderTypesModel =>
  data.map((apiOrderType) => apiOrderType.slug);
